<div class="container">
    <ul class="timeline">
      <li *ngFor="let item of list" [ngClass]="{'timeline-inverted': item?.params?.application != 'ONB'}">
        <div class="timeline-panel">
          <div class="timeline-heading">
            <div class="timeline-title h4">{{item?.status | filterList:statusList}}</div>
            <div class="text-muted font-weight-bold h5">
                {{visuals?.submittedOn}} : {{item?.timestamp  | date:'dd/MM/yyyy, HH:mm:ss'}} 
            </div>        
          </div>
          <div class="timeline-body" *ngIf="item?.params?.application == 'ONB'">
            <p>{{visuals?.supplierUserName}}: {{item?.params?.userName}}</p>
            <p>{{visuals?.supplierFname}}: {{item?.params?.firstName}}</p>
            <p>{{visuals?.supplierLname}}: {{item?.params?.lastName}}</p>
          </div>
          <div class="timeline-body" *ngIf="item?.params?.application == 'BO'">
            <p>{{visuals?.bankUserName}}: {{item?.params?.userName}}</p>
            <p>{{visuals?.bankUserFname}}: {{item?.params?.firstName}}</p>
            <p>{{visuals?.bankUserLname}}: {{item?.params?.lastName}}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
